import type { ReactNode } from "react";

/** A quiet, centered spinner in the reverent palette. */
export function Loading({ label = "Loading" }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 py-16 text-ink-faint">
      <span
        className="h-4 w-4 animate-spin rounded-full border-2 border-line-strong border-t-terracotta"
        aria-hidden
      />
      <span className="text-sm">{label}…</span>
    </div>
  );
}

export function EmptyState({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="rounded-2xl border border-line bg-paper-raised px-6 py-12 text-center">
      <p className="font-serif text-lg text-ink">{title}</p>
      {children ? (
        <div className="mt-2 text-sm text-ink-faint">{children}</div>
      ) : null}
    </div>
  );
}
